<div class="drag-drop-cell" *ngIf="params.data && !params.data.isEmptyDropRow" [attr.data-automation-id]="automationId"
    [dndDraggable]="params.data" (dndDrop)="params.onDrop($event.data, params.data)" dndDropzone
    [dndDisableDropIf]="params.isFiltering">
    <img *ngIf="params.showDragDots" class="drag-dots" src="assets/images/drag_grey.png"
        [attr.data-automation-id]="automationId + '-button'">
    <res-custom-checkbox *ngIf="params.showCheckboxes" [ngModel]="params.node.selected" [disabled]="isDisabled"
        [labelPaddingLeft]="10" [labelPaddingRight]="15" [automationId]="automationId" [notClickable]="true">
    </res-custom-checkbox>
    <span [attr.title]="params?.data?.tooltip?.length > 0 ? params.data.tooltip : params.value"
        [attr.data-automation-id]="automationId + '-text'">{{params.value}}</span>
    <button type="button" class="remove-row" *ngIf="params.isRowDeletable" (click)="params.deleteRow(params.data)"
        [attr.data-automation-id]="automationId + '-clear-button'">
        <i class="fa fa-trash-o"></i>
    </button>
</div>

<div class="drag-drop-cell empty-drop-cell" *ngIf="params.data && params.data.isEmptyDropRow"
    [ngClass]="[params.cellType ? params.cellType : '']" [attr.data-automation-id]="automationId" dndDropzone
    (dndDrop)="params.onDrop($event.data, params.data)">
    <span [attr.data-automation-id]="automationId + '-empty-cell'">Drag fields here ...</span>
</div>